import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
const play_triangle = (_a) => {
    var { size = 60 } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size, height: size }, props),
        React.createElement("path", { d: "M41.5,30l-17,10V20L41.5,30z" })));
};
play_triangle.displayName = 'play_triangle';
play_triangle.propTypes = {
    size: PropTypes.number
};
export default play_triangle;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=play_triangle.js.map